import React from "react";
import { useLandingLang } from "../../i18n/LandingLangContext";

// --- Icono Inline (Estilo Lucide: GraduationCap) ---
function GraduationCapIcon({ className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
      <path d="M6 12v5c3 3 9 3 12 0v-5" />
    </svg>
  );
}

export function AcademicPartners({ partners = [], resolveLogo }) {
  const { t } = useLandingLang();
  return (
    <section className="py-24 px-6 bg-white border-b border-slate-200 text-center">
      <div className="max-w-7xl mx-auto">
        {/* --- CABECERA --- */}
        <div className="mb-20 space-y-4">
          <span className="text-sky-500 !font-black tracking-widest uppercase text-xs">
            {t("academicTag")}
          </span>
          <h2 className="text-4xl !font-black tracking-tight text-slate-700">
            {t("academicTitle")}
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto font-medium">
            {t("academicDesc")}
          </p>
        </div>

        {/* --- GRID DE PARTNERS --- */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {partners.map((partner, i) => {
            // Resolvemos la URL del logo si viene como key o como url directa
            const logoSrc =
              typeof resolveLogo === "function" && partner.logoKey
                ? resolveLogo(partner.logoKey)
                : partner.logo || null;

            return (
              <div
                key={`${partner.name}-${i}`}
                className="flex flex-col items-center space-y-6 group"
              >
                {/* CAJA DEL LOGO
                    Estilos: w-full h-32 rounded-2xl bg-slate-50 border border-slate-100 
                    Hover: scale-105, bg-white, shadow-xl, shadow-sky-50
                */}
                <div className="w-full h-32 rounded-2xl bg-slate-50 border border-slate-100 flex items-center justify-center p-8 group-hover:scale-105 group-hover:bg-white group-hover:shadow-xl group-hover:shadow-sky-50 transition-all duration-500 overflow-hidden relative shadow-inner">
                  {logoSrc ? (
                    <img
                      src={logoSrc}
                      alt={partner.name}
                      className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                  ) : (
                    <GraduationCapIcon className="w-10 h-10 text-slate-300" />
                  )}
                </div>

                {/* TEXTOS */}
                <div>
                  {/* Nombre Institución */}
                  <h4 className="!font-black text-slate-700 uppercase tracking-tight text-sm">
                    {partner.name}
                  </h4>

                  {/* Laboratorio / Dept (Espaciado amplio tracking-[0.2em]) */}
                  <p className="text-[10px] !font-black text-sky-500 uppercase tracking-[0.2em] mb-2">
                    {partner.lab}
                  </p>

                  {/* Rol */}
                  <p className="text-xs text-slate-500 font-medium">
                    {t(partner.roleKey)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
